const DEFAULT_MAIN_ORIGIN = "https://bez-part.ru";

export function mainSiteOrigin(): string {
  const raw =
    (import.meta.env.VITE_MAIN_SITE_ORIGIN as string | undefined)?.trim() ||
    DEFAULT_MAIN_ORIGIN;
  return raw.replace(/\/+$/, "");
}

/**
 * Корень портала школы. Раньше здесь был жёстко прошит `/guest/` — кабинет
 * родителя, куда уезжали все подряд, включая преподавателей и внешних
 * пользователей. Роль знает сам портал, поэтому ведём на корень и не гадаем.
 */
export function mainSiteDashboardUrl(): string {
  return `${mainSiteOrigin()}/`;
}

/** Главная страница сервиса доски (после выхода из аккаунта доски). */
export function boardHomeUrl(): string {
  return "/";
}

/** @deprecated Logout основного сайта; для выхода с доски используйте boardHomeUrl после POST /api/v1/auth/logout */
export function mainSiteLogoutUrl(): string {
  return `${mainSiteOrigin()}/guest/pages/auth/logout`;
}

export function mainSiteLoginUrl(returnUrl?: string): string {
  const base = `${mainSiteOrigin()}/guest/pages/auth/login.php`;
  if (!returnUrl) return base;
  return `${base}?return=${encodeURIComponent(returnUrl)}`;
}

/** Вход через портал с автоматической выдачей JWT и сессии доски. */
export function mainSiteBoardLoginUrl(boardReturnPath?: string): string {
  let ret = (boardReturnPath ?? "/cabinet").trim();
  if (!ret.startsWith("/") || ret.startsWith("//")) {
    ret = "/cabinet";
  }
  if (ret.length > 512) {
    ret = "/cabinet";
  }
  const params = new URLSearchParams({ board_return: ret });
  return `${mainSiteOrigin()}/guest/pages/auth/board-login.php?${params}`;
}

export function formatCabinetUserName(email: string): string {
  const t = email.trim();
  if (!t || t.endsWith("@no-reply.bezpart-board.invalid")) {
    return "Пользователь";
  }
  return t;
}
